import api from './client';
import type {
  PesquisaAlmox,
  PesquisaEmpresa,
  PesquisaGrupo,
  PesquisaSubgrupo,
  PesquisaFornecedor,
  PesquisaMarca,
  PesquisaProduto,
  PesquisaProdutoAutocomplete,
  PesquisaAlmoxApi,
  PesquisaEmpresaApi,
  PesquisaGrupoApi,
  PesquisaSubgrupoApi,
  PesquisaFornecedorApi,
  PesquisaMarcaApi
} from '../types/pesquisas';
import { logError } from '../utils/clientLog';

class PesquisasService {
  
  async getAlmoxarifados(): Promise<PesquisaAlmox[]> {
    try {
      const response = await api.get<PesquisaAlmoxApi[]>('/pesquisas/almoxarifados');
      return response.data.map((almox) => ({
        ...almox,
        isSelected: false
      }));
    } catch (error) {
      logError('Erro ao buscar almoxarifados:', error);
      throw error;
    }
  }

  async getEmpresas(): Promise<PesquisaEmpresa[]> {
    try {
      const response = await api.get<PesquisaEmpresaApi[]>('/pesquisas/empresas');
      return response.data.map((empresa) => ({
        ...empresa,
        isSelected: false
      }));
    } catch (error) {
      logError('Erro ao buscar empresas:', error);
      throw error;
    }
  }

  async getGrupos(): Promise<PesquisaGrupo[]> {
    try {
      const response = await api.get<PesquisaGrupoApi[]>('/pesquisas/grupos');
      return response.data.map((grupo) => ({
        ...grupo,
        isSelected: false
      }));
    } catch (error) {
      logError('Erro ao buscar grupos:', error);
      throw error;
    }
  }

  async getSubgrupos(): Promise<PesquisaSubgrupo[]> {
    try {
      const response = await api.get<PesquisaSubgrupoApi[]>('/pesquisas/subgrupos');
      return response.data.map((s) => ({
        ...s,
        isSelected: false
      }));
    } catch (error) {
      logError('Erro ao buscar subgrupos:', error);
      throw error;
    }
  }

  async getFornecedores(): Promise<PesquisaFornecedor[]> {
    try {
      const response = await api.get<PesquisaFornecedorApi[]>('/pesquisas/fornecedores');
      return response.data.map((fornecedor) => ({
        ...fornecedor,
        isSelected: false
      }));
    } catch (error) {
      logError('Erro ao buscar fornecedores:', error);
      throw error;
    }
  }

  async getMarcas(): Promise<PesquisaMarca[]> {
    try {
      const response = await api.get<PesquisaMarcaApi[]>('/pesquisas/marcas');
      return response.data.map((marca) => ({
        ...marca,
        isSelected: false
      }));
    } catch (error) {
      logError('Erro ao buscar marcas:', error);
      throw error;
    }
  }

  // Método para buscar produtos (caso seja implementado no backend)
  async getProdutos(): Promise<PesquisaProduto[]> {
    try {
      // Por enquanto retorna array vazio, será implementado quando houver no backend
      return [];
    } catch (error) {
      logError('Erro ao buscar produtos:', error);
      throw error;
    }
  }

  /**
   * Autocomplete de produtos pra feature "Adicionar produto" na /compras/analise.
   * Mínimo 2 caracteres no termo — backend ignora consultas menores e devolve [].
   */
  async getProdutosAutocomplete(query: string, limit = 20): Promise<PesquisaProdutoAutocomplete[]> {
    const q = (query ?? '').trim();
    if (q.length < 2) return [];
    const response = await api.get<PesquisaProdutoAutocomplete[]>('/pesquisas/produtos', {
      params: { q, limit },
    });
    return response.data ?? [];
  }
}

export const pesquisasService = new PesquisasService();